import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Checkbox,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText,
    Autocomplete,
    Stack
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/plus.svg";
import { ReactComponent as Delete } from "../../../../assets/icons/delete.svg";
import { ReactComponent as Calendar } from "../../../../assets/icons/calendar.svg";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { ReactComponent as Eye } from "../../../../assets/images/eye.svg";
import DialogPreview from "../../../../components/kpi/DialogPreview";
import adminService from "../../../../services/admin.service";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const TargetGroupCreate = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
        getListCriteria()
    }, []);
    // position: absolute; bottom: -24px
    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        fieldsetError: {
            '& div > fieldset': {
                "border-color": "#CC6058"
            }
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },
        inputTopic: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12px 14px",
                "font-size": "16px",
                height: '8px',
                position: "relative"
            }
        },
        inputTopicError: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12px 14px",
                "font-size": "16px",
                height: '8px',
                position: "relative"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        select: {
            '& div ': {
                padding: "8.5px 8.5px 8.5px 15px"
            },
        },
        selectError: {
            background: "#CC6058",
            '& div ': {
                padding: "8.5px 8.5px 8.5px 15px"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            },
        },
        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        width50: {
            width: "calc(50% - 80px)",
            margin: "0 40px",
        },
        width100: {
            width: "calc(50% - 80px)",
            margin: "0 40px",
        },
        boxInput: {
            ".MuiFormControl-root": {
                "margin-top": "7px"
            }
        },
        styleTag: {
            '& div > .MuiOutlinedInput-root': {
                '& .MuiChip-root': {
                    backgroundColor: "#5DA196",
                    color: "#ffffff",
                    borderRadius: "3px",
                    '& .MuiChip-deleteIcon': {
                        color: "#ffffff",
                    }
                },
            },
        },
        fillGrey: {
            '& > path': {
                fill: "#D8D8D8 !important",
            },
            '& g > path': {
                fill: "#D8D8D8 !important",
            },
        },
        fillGreyStroke: {
            '& > path': {
                stroke: "#D8D8D8 !important"
            },
            '& g > path': {
                stroke: "#D8D8D8 !important"
            },
        },
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const classes = useStyles();
    let { cycleID } = useParams()
    const [criteria, setCriteria] = React.useState([]);
    const [forManager, setForManager] = React.useState([]);
    const [status, setStatus] = React.useState(true);
    const [onSubmit, setOnSubmit] = React.useState(false);
    const [checkCode, setCheckCode] = React.useState(false);
    const [valueCriteria, setValueCriteria] = React.useState("");
    const [valueSubCriteria, setValueSubCriteria] = React.useState([]);
    const [ids, setIDS] = React.useState([]);
    const [idsDisplay, setIDSDisplay] = React.useState([]);
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const [errorText, seterrorText] = React.useState("");
    const [typeSubmit, setTypeSubmit] = React.useState("");
    const onCheckStartDate = (val) => {
        setStartDate(Util.formatDate(val))
    }
    const onCheckEndDate = (val) => {
        setEndDate(Util.formatDate(val))
    }
    const handleStatus = () => {
        setStatus(!status)
    }
    const top100Films = [
        { title: 'The Shawshank Redemption', year: 1994 },
        { title: 'The Godfather', year: 1972 },
        { title: 'The Godfather: Part II', year: 1974 },
        { title: 'The Dark Knight', year: 2008 },
        { title: '12 Angry Men', year: 1957 },
        { title: "Schindler's List", year: 1993 },
        { title: 'Pulp Fiction', year: 1994 },
        { title: 'City of God', year: 2002 },
        { title: 'Se7en', year: 1995 },
        { title: 'The Silence of the Lambs', year: 1991 },
        { title: "It's a Wonderful Life", year: 1946 },
        { title: 'Life Is Beautiful', year: 1997 },
        { title: 'The Usual Suspects', year: 1995 },
        { title: 'Léon: The Professional', year: 1994 },
        { title: 'Spirited Away', year: 2001 },
        { title: 'Saving Private Ryan', year: 1998 },
        { title: 'Once Upon a Time in the West', year: 1968 },
        { title: 'American History X', year: 1998 },
        { title: 'Interstellar', year: 2014 },
    ];

    const [listsType, setListsType] = React.useState({});

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));
    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        name: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
    });
    const formik = useFormik({
        initialValues: {
            code: '',
            // status: status,
            name: '',
            description: '',
            criteria: [],
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            if (typeSubmit === "view") {
                let checkDataCode = values.criteria.filter((rs) => rs.code === "")
                let checkDataIds = values.criteria.filter((rs) => rs.code !== "employee_hire_date" && rs?.ids === undefined)
                let checkDataIds2 = values.criteria.filter((rs) => rs.code !== "employee_hire_date" && rs?.ids.length === 0)
                let checkDataFormik = values.criteria.filter((rs) => rs.code === "employee_hire_date")
                let checkDateFrom = checkDataFormik.filter((rs) => rs?.condition?.date_from === "" || rs?.condition?.date_from === undefined || rs?.condition?.date_from === null)
                if (checkDataCode.length === 0 && checkDateFrom.length === 0 && checkDataIds.length === 0 && checkDataIds2.length === 0) {
                    onOpenPreview()
                }
            } else {
                let checkDataCode = values.criteria.filter((rs) => rs.code === "")
                let checkDataIds = values.criteria.filter((rs) => rs.code !== "employee_hire_date" && rs?.ids === undefined)
                let checkDataIds2 = values.criteria.filter((rs) => rs.code !== "employee_hire_date" && rs?.ids.length === 0)
                let checkDataFormik = values.criteria.filter((rs) => rs.code === "employee_hire_date")
                let checkDateFrom = checkDataFormik.filter((rs) => rs?.condition?.date_from === "" || rs?.condition?.date_from === undefined || rs?.condition?.date_from === null)
                if (checkDataCode.length === 0 && checkDateFrom.length === 0 && checkDataIds.length === 0 && checkDataIds2.length === 0) {
                    adminService.checkCode("target_group", values.code).then(
                        (response) => {
                            setCheckCode(response?.data?.is_exist)
                            if (response?.data?.is_exist === false) {
                                submit(values)
                            }
                        },
                    ).catch(() => {
                    })
                }
            }
        },
    });
    useEffect(() => {
        if (checkCode === true) {
            setCheckCode(false)
        }
    }, [formik.values.code]);
    const checkData = () => {
        let findDataCriteria = formik.values.criteria.length > 0 ? formik.values.criteria.filter((res) => res.type !== "" && res.code !== "") : []
        if (findDataCriteria !== undefined) {
            if (formik.values.criteria.length > 0) {
                // if (findDataCriteria !== undefined && findDataCriteria.length > 0 && findDataCriteria.length === formik.values.Criteria.length &&
                //     findDataForManager !== undefined && findDataForManager.length > 0 && findDataForManager.length === formik.values.forManager.length) {
                //     return true;
                // }
                return false;
            } else if (formik.values.criteria.length > 0 && findDataCriteria !== undefined && findDataCriteria.length > 0 && findDataCriteria.length === formik.values.criteria.length) {
                return true;
            }
        }
        return false;
    }
    const checkDataOne = (data) => {
        let findData = data.filter((res) => res.type !== "" && res.code !== "")
        if (findData !== undefined && findData.length > 0 && findData.length === data.length) {
            return true;
        }
        return false;
    }

    const handleSubmit = (type) => {
        setTypeSubmit(type)
        let findDataCriteria = formik.values.criteria.filter((res) => res.type === "" && res.code === "")
        // let findDataForManager = formik.values.forManager.filter((res) => res.topic === "" && res.code === "")
        if (findDataCriteria !== undefined && findDataCriteria.length > 0) {
            let data = []
            for (let index = 0; index <= formik.values.criteria.length - 1; index++) {
                if (formik.values.criteria[index].code !== "" || formik.values.criteria[index].type !== "") {
                    if (formik.values.criteria[index].code === "" && formik.values.criteria[index].type === "") {

                    } else {
                        data.push(formik.values.criteria[index])
                    }
                }
            }
            setCriteria(data)
            formik.setFieldValue("criteria", data)
        }
        // if (findDataForManager !== undefined && findDataForManager.length > 0 && findDataForManager.length !== formik.values.forManager.length) {
        //     let data = []
        //     for (let index = 0; index <= formik.values.forManager.length - 1; index++) {
        //         if (formik.values.forManager[index].code !== "" || formik.values.forManager[index].topic !== "") {
        //             if (formik.values.forManager[index].code === "" && formik.values.forManager[index].topic === "") {

        //             } else {
        //                 data.push(formik.values.forManager[index])
        //             }
        //         }
        //     }
        //     setForManager(data)
        //     formik.setFieldValue("forManager", data)
        // }
        formik.submitForm()
        setOnSubmit(true)
    }
    useEffect(() => {
        addCriteria()
    }, [])
    const addCriteria = () => {
        setCriteria([...criteria, {}])
        formik.setFieldValue("criteria", [...formik.values.criteria, { type: "include", code: "" }])
    }
    const onCheckboxChange = (dataCheck, field, subField, index, type) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        data[field][index] = { ...formik.values[field][index], "condition": formik.values[field][index].condition !== undefined && formik.values.criteria[index].code === "organization" ? { ...formik.values[field][index].condition, [subField]: dataCheck.target.checked } : { [subField]: dataCheck.target.checked } }
        formik.setFieldValue(field, data[field])
    }
    const formikChange = (val, field, subField, index, type) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        let result = []
        let display = []
        if (subField === "ids") {
            for (let index = 0; index <= val.length - 1; index++) {
                result.push(val[index].serial)
                display.push(val[index])
                setIDSDisplay([...display])
                setIDS([...result])
            }
        }
        data[field][index] = { ...formik.values[field][index], [subField]: "ids" === subField ? [...result] : val.target.value, "idsDisplay": [...display], "condition": val?.target?.value === "organization" ? { "include_sub_organization": false } : {} }
        if (subField === "code") {
            if (val.target.value !== undefined && val.target.value !== null && val.target.value !== "") {
                adminService.listSubCriteria(val.target.value).then(
                    (response) => {
                        setValueCriteria(val.target.value);
                        setValueSubCriteria({ ...valueSubCriteria, [val.target.value]: response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')] !== undefined && response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')].length > 0 ? [{ label: t('label.selectAll'), value: "select-all" }, ...response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')]] : response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')] });
                    },
                )
            }
        }
        if (subField === "type") {
            data[field][index] = { type: val.target.value, code: "" }
        }

        formik.setFieldValue(field, data[field])
    }

    const formikChangeOrganization = (val, field, subField, index, allData, type) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        let result = []
        let display = []
        if (type === "select") {
            data[field][index] = { ...formik.values[field][index], [subField]: [val.target.value], "idsDisplay": val.target.value }
        } else {
            let findVal = val.filter((rs) => rs?.value === "select-all")
            let findAllData = allData.filter((rs) => rs?.value !== "select-all")
            if (subField === "ids" && findVal.length === 0) {
                for (let index = 0; index <= val.length - 1; index++) {
                    result.push(val[index].serial)
                    display.push(val[index])
                    setIDSDisplay([...display])
                    setIDS([...result])
                }
            }
            if (subField === "ids" && findVal.length > 0) {
                if (data[field][index][subField] === undefined) {
                    for (let index = 0; index <= findAllData.length - 1; index++) {
                        result.push(findAllData[index].serial)
                        display.push(findAllData[index])
                        setIDSDisplay([...display])
                        setIDS([...result])
                    }
                } else {
                    if (data[field][index][subField].length >= 0 && findAllData.length > data[field][index][subField].length) {
                        for (let index = 0; index <= findAllData.length - 1; index++) {
                            result.push(findAllData[index].serial)
                            display.push(findAllData[index])
                            setIDSDisplay([...display])
                            setIDS([...result])
                        }
                    }
                }

            }
            data[field][index] = { ...formik.values[field][index], [subField]: "ids" === subField ? [...result] : val.target.value, "idsDisplay": [...display] }
            if (subField === "code") {
                if (val.target.value !== undefined && val.target.value !== null && val.target.value !== "") {
                    adminService.listSubCriteria(val.target.value).then(
                        (response) => {
                            setValueCriteria(val.target.value);
                            setValueSubCriteria({ ...valueSubCriteria, [val.target.value]: response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')] !== undefined && response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')].length > 0 ? [{ label: t('label.selectAll'), value: "select-all" }, ...response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')]] : response.data[Object.keys(response.data).find((rs) => rs !== 'cycle')] });
                        },
                    )
                }
            }
        }

        formik.setFieldValue(field, data[field])
    }

    const formikChangeDate = (val, field, subField, index, type) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        data[field][index] = { ...formik.values[field][index], "ids": [], "condition": formik.values[field][index].condition !== undefined ? { ...formik.values[field][index].condition, [subField]: Util.formatDate(val) } : { [subField]: Util.formatDate(val) } }
        formik.setFieldValue(field, data[field])
    }
    const formikDelete = (dataLoop, field, setData, index) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        let dataShow = JSON.parse(JSON.stringify(dataLoop))
        data[field].splice(index, 1)
        dataShow.splice(index, 1)
        setData(dataShow)
        formik.setFieldValue(field, data[field])
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }

    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        openDialog(false);
        navigate('/admin/target-group', { replace: false });
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const handleOpenDialog = (value) => {
        openDialog(true);
    };
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/target-group', { replace: false });
    }
    const submit = (data) => {
        for (let index = 0; index <= data.criteria.length - 1; index++) {
            data.criteria[index].seq = index + 1
        }
        adminService.createTargetGroup({
            // cycle: cycleID,
            code: data.code,
            name: data.name,
            description: data.description,
            criteria: data.criteria,
            status: status === true ? "active" : "inactive",
        }).then(
            (response) => {
                openSuccessAddDialog(true)
            },
        ).catch(() => {
            seterrorText(t(`admin.label.GoalCategoryCreatedFail`))
            handleOpenFailedMessageDialog(true)
        })
    }
    const [openPreview, setOpenPreview] = React.useState(false);
    const onOpenPreview = () => {
        setOpenPreview(true)
    }
    const onClosePreview = () => {
        setOpenPreview(false)
    }
    const getListCriteria = () => {
        adminService.listCriteria().then(
            (response) => {
                let criteria = []
                for (let index = 0; index <= Object.keys(response.data.criteria).length - 1; index++) {
                    criteria[index] = response.data.criteria[Object.keys(response.data.criteria)[index]]
                }
                setListsType(criteria)
                // for (let indexs = 0; indexs <= criteria.length - 1; indexs++) {

                // }
            },
        )
    }
    let checkSelectCode = (code, type, selectCode) => {
        if (formik?.values?.criteria !== undefined && formik?.values?.criteria.length > 0) {
            let checkFormit = formik?.values?.criteria.filter((rs) => rs.code === code && rs.type === type && rs.code !== selectCode)
            if (checkFormit.length > 0) {
                return "none";
            }
        }
        return "";
    }

    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/target-group')}>{t('admin.label.targetGroup')}</span> / <span style={styles.end} >{t('admin.label.createTargetGroup')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {t('admin.label.createTargetGroup')}
                            </Typography>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">

                            <Grid container item>
                                <Paper sx={{ padding: "40px 40px 20px", "box-shadow": " 0px 2px 10px rgba(0, 0, 0, 0.1)", "border-radius": "10px", width: '100%' }} classes={{ root: classes.error }}>
                                    <Box display="flex" sx={{ margin: "0 -40px", flexFlow: "row wrap" }}>
                                        <Box sx={{ width: "calc(50% - 80px)", margin: "0 40px", position: "relative", ".MuiFormControl-root": { "margin-top": "7px" }, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }} >
                                            <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.code')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.code && formik.errors.code) === false ? checkCode === true ? true : false : true}
                                                fullWidth
                                                helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="code"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.code}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.code')}
                                                classes={{ root: classes.input }}
                                            />
                                            {Boolean(formik.touched.code && formik.errors.code) === false && checkCode === true ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginBottom: "8px", marginLeft: "14px" }}>{t('label.alreadyUsed')} </FormHelperText>) : <></>}
                                        </Box>
                                        <Box sx={{ width: "calc(50% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" } }}>
                                            <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Box sx={{ "margin-top": "7px", height: "41px", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0 }}
                                                        control={<IOSSwitch checked={status} onChange={() => handleStatus()} />}
                                                        label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    // disabled
                                                    />
                                                </FormGroup>
                                                {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography> */}
                                            </Box>
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" }, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }}>
                                            <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.name')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.name && formik.errors.name)}
                                                fullWidth
                                                helperText={formik.touched.name && formik.errors.name}
                                                margin="normal"
                                                name="name"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.name}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.name')}
                                                classes={{ root: classes.input }}
                                            />
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" } }}>
                                            <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.description')}</Typography>
                                            <TextField
                                                fullWidth
                                                margin="normal"
                                                name="description"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.description}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.description')}
                                                classes={{ root: classes.input }}
                                            />
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px" }}>
                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                <Typography variant="subtitle1" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.criteria')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                <Button color="black" variant="outlined" onClick={e => handleSubmit("view")}>
                                                    <Eye />
                                                    <Typography pl="5px" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex" sx={{ textTransform: "none" }}>{t('label.preview')}</Typography>
                                                </Button>
                                            </Box>
                                            <Box sx={{ position: "relative" }}>
                                                <Box mt="10px" sx={{ border: onSubmit === true ? criteria.length === 0 ? "1px solid #CC6058" : "1px solid #CED4DA" : "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px", padding: "17px 29px" }}>
                                                    <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }} mb="15px">
                                                        <Typography fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" display="flex" sx={{ textTransform: "uppercase" }}>{t('admin.inputForm.ManageCriteria')}</Typography>
                                                        <Box onClick={addCriteria} sx={{ cursor: "pointer", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }}>
                                                            <PlusIcon />
                                                            <Typography pl="5px" fontWeight="500" color="#5DA196" fontSize={18} lineHeight="26.91px" display="flex">{t('label.add')}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Divider />
                                                    <Box sx={{ overflow: "hidden", height: "100%", transition: "all .8s", "max-height": criteria !== undefined && criteria !== null && criteria.length > 0 ? "999999px" : "0px" }}>
                                                        {criteria !== undefined && criteria !== null && criteria.length > 0 ?
                                                            <Box pb="16px">
                                                                {criteria.map((item, index) => (
                                                                    <Box sx={{ width: "100%" }} >
                                                                        <Box sx={{ height: "100%", padding: "15px", display: "flex", "align-items": "center", flexFlow: "row wrap" }}>
                                                                            <Box sx={{ width: "calc(30% - 30px)" }} mr="30px">
                                                                                <Select
                                                                                    // id={`${item.key}`}
                                                                                    variant="outlined"
                                                                                    defaultValue=""
                                                                                    displayEmpty
                                                                                    size="small"
                                                                                    placeholder={t('admin.inputForm.placeholder.selectAnswerType')}
                                                                                    fullWidth
                                                                                    // disabled={item.edit === false ? true : false}selectError
                                                                                    className="white-bg"
                                                                                    onChange={e => formikChange(e, "criteria", "type", index, "select")}
                                                                                    value={formik.values.criteria[index].type}
                                                                                    classes={onSubmit === true ? formik.values.criteria[index].type === "" ? { root: classes.selectError } : { root: classes.select } : { root: classes.select }}
                                                                                >
                                                                                    <MenuItem disabled value="" key="0">
                                                                                        <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t("admin.inputForm.placeholder.selectAnswerType")} </Typography>
                                                                                    </MenuItem>
                                                                                    <MenuItem value="include" key="1" >
                                                                                        <Typography style={{ fontWeight: "400", fontSize: "16px", fontHeight: "16px", color: '#404349' }}>Include</Typography>
                                                                                    </MenuItem>
                                                                                    <MenuItem value="exclude" key="2" >
                                                                                        <Typography style={{ fontWeight: "400", fontSize: "16px", fontHeight: "16px", color: '#404349' }}>Exclude</Typography>
                                                                                    </MenuItem>
                                                                                </Select>
                                                                            </Box>
                                                                            <Box sx={{ width: "calc(70% - 60px)" }} pr="30px">
                                                                                <Select
                                                                                    // id={`${item.key}`}
                                                                                    variant="outlined"
                                                                                    defaultValue=""
                                                                                    displayEmpty
                                                                                    size="small"
                                                                                    placeholder={t('admin.inputForm.placeholder.selectCriteria')}
                                                                                    fullWidth
                                                                                    // disabled={item.edit === false ? true : false}selectError
                                                                                    className="white-bg"
                                                                                    onChange={e => formikChange(e, "criteria", "code", index, "select")}
                                                                                    value={formik.values.criteria[index].code}
                                                                                    // classes={{ root: classes.select }}
                                                                                    classes={onSubmit === true ? formik.values.criteria[index].code === "" ? { root: classes.selectError } : { root: classes.select } : { root: classes.select }}
                                                                                // onChange={selectField(`${item.key}`)}
                                                                                // sx={Boolean(formik.touched[item.key] && formik.errors[item.key]) ? { border: "0.5px solid red", marginTop: "10px", marginBottom: 0 } : { marginTop: "10px", marginBottom: 0 }}
                                                                                >
                                                                                    <MenuItem disabled value="" key="0">
                                                                                        <Typography variant="sub_label" style={{ fontWeight: "300" }}>{t("admin.inputForm.placeholder.selectCriteria")} </Typography>
                                                                                    </MenuItem>
                                                                                    {
                                                                                        listsType?.length > 0 ?
                                                                                            listsType.map(item => {
                                                                                                return (
                                                                                                    <MenuItem value={item.code} key={item.code} sx={{ display: checkSelectCode(item.code, formik.values.criteria[index].type, formik.values.criteria[index].code) }}>
                                                                                                        <Typography style={{ fontWeight: "400", fontSize: "16px", fontHeight: "16px", color: '#404349' }}>{item.name}</Typography>
                                                                                                    </MenuItem>
                                                                                                )
                                                                                            })
                                                                                            : <MenuItem value="">
                                                                                                ไม่พบข้อมูล
                                                                                            </MenuItem>
                                                                                    }
                                                                                </Select>
                                                                            </Box>
                                                                            {criteria.length === 1 ?
                                                                                <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }}>
                                                                                    <Delete style={{ cursor: "default" }} className={classes.fillGrey} />
                                                                                </Box>
                                                                                :
                                                                                <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }}>
                                                                                    <Delete style={{ cursor: "pointer" }} onClick={e => formikDelete(criteria, "criteria", setCriteria, index)} />
                                                                                </Box>
                                                                            }
                                                                            {formik.values.criteria[index].code !== undefined && formik.values.criteria[index].code !== "" ?
                                                                                formik.values.criteria[index].code === "employee_hire_date" ?
                                                                                    <Box display="flex" sx={{ width: "100%" }}>
                                                                                        <Box pt="12px" sx={{ '.MuiOutlinedInput-notchedOutline': { "border-color": onSubmit === true ? formik.values.criteria[index]?.condition?.date_from === "" || formik.values.criteria[index]?.condition?.date_from === undefined || formik.values.criteria[index]?.condition?.date_from === null ? "#CC6058" : "" : "" }, width: "calc(30% - 30px)", ".MuiButtonBase-root": { "justify-content": "flex-end", position: "absolute", width: "100%", height: "100%", left: "0", "border-radius": "unset" }, ".MuiFormControl-root": { "margin-top": "7px" }, '& div > div > input': { height: '7px', }, position: "relative" }} mr="30px" >
                                                                                            <LocalizationProvider dateAdapter={AdapterDateFns} >
                                                                                                <DatePicker
                                                                                                    slots={{
                                                                                                        OpenPickerIcon: Calendar
                                                                                                    }}
                                                                                                    format="dd/MM/yyyy"
                                                                                                    value={formik.values.criteria[index]?.condition?.date_from !== undefined ? formik.values.criteria[index]?.condition?.date_from : null}
                                                                                                    onChange={(newValue) => {
                                                                                                        // onCheckStartDate(newValue)
                                                                                                        formikChangeDate(newValue, "criteria", "date_from", index, "date")
                                                                                                    }}
                                                                                                    inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true }}
                                                                                                    renderInput={(params) => <TextField {...params}
                                                                                                        fullWidth
                                                                                                    />
                                                                                                    }
                                                                                                />
                                                                                            </LocalizationProvider>
                                                                                            {onSubmit === true ? formik.values.criteria[index]?.condition?.date_from === "" || formik.values.criteria[index]?.condition?.date_from === undefined || formik.values.criteria[index]?.condition?.date_from === null ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></> : <></>}
                                                                                        </Box>
                                                                                        <Box pt="12px" sx={{ width: "calc(30% - 30px)", ".MuiButtonBase-root": { "justify-content": "flex-end", position: "absolute", width: "100%", height: "100%", left: "0", "border-radius": "unset" }, ".MuiFormControl-root": { "margin-top": "7px" }, '& div > div > input': { height: '7px', } }}>
                                                                                            <LocalizationProvider dateAdapter={AdapterDateFns} >
                                                                                                <DatePicker
                                                                                                    slots={{
                                                                                                        OpenPickerIcon: Calendar
                                                                                                    }}
                                                                                                    format="dd/MM/yyyy"
                                                                                                    value={formik.values.criteria[index]?.condition?.date_to !== undefined ? formik.values.criteria[index]?.condition?.date_to : null}
                                                                                                    onChange={(newValue) => {
                                                                                                        // onCheckEndDate(newValue)
                                                                                                        formikChangeDate(newValue, "criteria", "date_to", index, "date")
                                                                                                    }}
                                                                                                    inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true }}
                                                                                                    renderInput={(params) => <TextField {...params}
                                                                                                        fullWidth
                                                                                                    />
                                                                                                    }
                                                                                                />
                                                                                            </LocalizationProvider>
                                                                                        </Box>
                                                                                    </Box>
                                                                                    :
                                                                                    valueSubCriteria[formik?.values?.criteria[index]?.code] !== undefined ?
                                                                                        <Box display="flex" alignItems="center" sx={{ width: "100%", flexFlow: "row wrap" }} mt="20px">
                                                                                            {formik.values.criteria[index]?.code === "with_subordinate" ?
                                                                                                <Box sx={{ '.MuiOutlinedInput-notchedOutline': { "border-color": onSubmit === true ? formik.values.criteria[index].idsDisplay !== "" && formik.values.criteria[index].idsDisplay !== undefined && formik.values.criteria[index].idsDisplay !== null && formik.values.criteria[index].idsDisplay.length > 0 ? "" : "#CC6058" : "" }, minWidth: "calc(30% - 30px)" }} mr="30px" >
                                                                                                    <Select
                                                                                                        // id={`${item.key}`}
                                                                                                        variant="outlined"
                                                                                                        defaultValue=""
                                                                                                        displayEmpty
                                                                                                        size="small"
                                                                                                        placeholder="Select"
                                                                                                        fullWidth
                                                                                                        // disabled={item.edit === false ? true : false}selectError
                                                                                                        className="white-bg"
                                                                                                        onChange={e => formikChangeOrganization(e, "criteria", "ids", index, valueSubCriteria[formik?.values?.criteria[index]?.code], "select")}
                                                                                                        value={formik.values.criteria[index]?.idsDisplay}
                                                                                                    >
                                                                                                        <MenuItem disabled value="" key="0" sx={{ display: "none" }}>
                                                                                                            <Typography variant="sub_label" style={{ fontWeight: "300" }}>Select</Typography>
                                                                                                        </MenuItem>
                                                                                                        {Util.formatData(valueSubCriteria[formik?.values?.criteria[index]?.code], []).map((rs) =>
                                                                                                            <MenuItem value={rs?.code} key={rs?.code} >
                                                                                                                <Typography style={{ fontWeight: "400", fontSize: "16px", fontHeight: "16px", color: '#404349' }}>{rs?.name}</Typography>
                                                                                                            </MenuItem>
                                                                                                        )}
                                                                                                    </Select>
                                                                                                    {onSubmit === true ? formik.values.criteria[index].idsDisplay !== "" && formik.values.criteria[index].idsDisplay !== undefined && formik.values.criteria[index].idsDisplay !== null && formik.values.criteria[index].idsDisplay.length > 0 ? <></> : (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                                                                                                </Box>
                                                                                                :
                                                                                                <Box sx={{ '.MuiOutlinedInput-notchedOutline': { "border-color": onSubmit === true ? formik.values.criteria[index].idsDisplay !== "" && formik.values.criteria[index].idsDisplay !== undefined && formik.values.criteria[index].idsDisplay !== null && formik.values.criteria[index].idsDisplay.length > 0 ? "" : "#CC6058" : "" }, minWidth: "calc(30% - 30px)" }} mr="30px" >
                                                                                                    <Autocomplete
                                                                                                        multiple
                                                                                                        id="checkboxes-tags-demo"
                                                                                                        size="small"
                                                                                                        fullWidth
                                                                                                        options={valueSubCriteria[formik?.values?.criteria[index]?.code]}
                                                                                                        disableCloseOnSelect
                                                                                                        value={formik.values.criteria[index]?.idsDisplay}
                                                                                                        onChange={(event, newValue) => {
                                                                                                            formikChangeOrganization(newValue, "criteria", "ids", index, valueSubCriteria[formik?.values?.criteria[index]?.code])
                                                                                                        }}
                                                                                                        classes={onSubmit === true ? formik.values.criteria[index].idsDisplay === "" ? { root: classes.selectError, root: classes.styleTag } : { root: classes.select, root: classes.styleTag } : { root: classes.select, root: classes.styleTag }}
                                                                                                        getOptionLabel={(option) => option?.code + ' - ' + option?.name}
                                                                                                        renderOption={(props, option, { selected }) => (
                                                                                                            <li {...props}>
                                                                                                                {option?.value === undefined ? <Checkbox
                                                                                                                    icon={icon}
                                                                                                                    checkedIcon={checkedIcon}
                                                                                                                    style={{ marginRight: 8 }}
                                                                                                                    checked={option?.value === undefined ? selected : valueSubCriteria[formik?.values?.criteria[index]?.code].length - 1 === formik.values.criteria[index]?.idsDisplay.length}
                                                                                                                /> :
                                                                                                                    <Checkbox
                                                                                                                        icon={icon}
                                                                                                                        checkedIcon={checkedIcon}
                                                                                                                        style={{ marginRight: 8 }}
                                                                                                                        indeterminate={valueSubCriteria[formik?.values?.criteria[index]?.code].length - 1 !== formik.values.criteria[index]?.idsDisplay.length && formik.values.criteria[index]?.idsDisplay.length > 0}
                                                                                                                        checked={option?.value === undefined ? selected : valueSubCriteria[formik?.values?.criteria[index]?.code].length - 1 === formik.values.criteria[index]?.idsDisplay.length}
                                                                                                                    />}

                                                                                                                {option?.value === undefined ? `${option?.code} - ${option?.name}` : option?.label}
                                                                                                            </li>
                                                                                                        )}
                                                                                                        style={{ width: "100%" }}
                                                                                                        renderInput={(params) => (
                                                                                                            <TextField
                                                                                                                {...params}
                                                                                                                // defaultValue=""
                                                                                                                // displayEmpty
                                                                                                                // placeholder={formik.values.criteria[index]?.idsDisplay !== undefined && formik.values.criteria[index]?.idsDisplay !== null && formik.values.criteria[index]?.idsDisplay !== "" ? "" : `Select ${formik.values.criteria[index].code}` }
                                                                                                                placeholder={`Select`}
                                                                                                                InputLabelProps={{
                                                                                                                    ...params.inputProps,
                                                                                                                    shrink: true,
                                                                                                                }}
                                                                                                            />
                                                                                                        )}
                                                                                                    />
                                                                                                    {onSubmit === true ? formik.values.criteria[index].idsDisplay !== "" && formik.values.criteria[index].idsDisplay !== undefined && formik.values.criteria[index].idsDisplay !== null && formik.values.criteria[index].idsDisplay.length > 0 ? <></> : (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                                                                                                </Box>
                                                                                            }
                                                                                            {formik.values.criteria[index].code === "organization" ?
                                                                                                <Box item display="flex" alignItems="center">
                                                                                                    <Checkbox color="primary" sx={{ pl: 0 }} onClick={e => onCheckboxChange(e, "criteria", "include_sub_organization", index, "checkbox")} checked={formik.values.criteria[index]?.condition?.include_sub_organization} />
                                                                                                    <Typography variant="subtitle1" fontSize={16} lineHeight="23.92px" fontWeight={500}>Include Sub-Organization</Typography>
                                                                                                </Box>
                                                                                                : null
                                                                                            }
                                                                                        </Box>
                                                                                        :
                                                                                        null
                                                                                : null
                                                                            }
                                                                        </Box>
                                                                        <Divider />
                                                                    </Box>
                                                                ))
                                                                }
                                                            </Box>
                                                            :
                                                            null
                                                        }
                                                    </Box>
                                                </Box>
                                                {onSubmit === true ? criteria.length > 0 || forManager.length > 0 ? criteria.length > 0 && checkDataOne(formik.values.criteria) === false ?
                                                    <Typography fontWeight="400" color="#d32f2f" fontSize="0.75rem" lineHeight="1.66" sx={{ position: "absolute", "margin-top": "3px", "margin-right": "14px", "margin-bottom": "0", "margin-left": "14px" }}>{t('admin.inputForm.msgError.code')}</Typography>
                                                    : null : null : null}
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box mt="30px">
                                        <Box display="flex" flexDirection="row-reverse">
                                            <Box sx={{ width: "100px" }}>
                                                <Button onClick={e => handleSubmit("submit")} color="primary" variant="contained" fullWidth sx={{ textTransform: "none", }}>
                                                    {t('label.create')}
                                                </Button>
                                            </Box>
                                            <Box mr={2} sx={{ width: "100px" }}>
                                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none", }}>
                                                    {t('label.cancel')}
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={t('admin.label.targetGroupCreatedSuccessfully')}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={t(`admin.label.targetGroupCreatedFail`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                    <DialogPreview open={openPreview} data={formik.values} close={onClosePreview} />
                </Container>
            </Box >
        </>
    )
};
export default TargetGroupCreate;
